import { useEffect, useMemo, useState } from "react";
import useClientConfig from "./common/hooks/clientConfigHook";
import useCredentials from "./common/hooks/credentialsHook";
import { useTranslation } from "react-i18next";
import { GuideContextProvider } from "./common/utils/GuideContext";

const buildUserInfo = (t, clientConfig, credentials) => {
    const translations = ['job_one','job_other','site_one','site_other','level_one','level_other','type_one','type_other','problem_one','problem_other','crew_one','crew_other']
    const props = {
        enableSites: clientConfig.enableSites,
        enableLevels: clientConfig.enableLevels,
    }
    translations.forEach(f => props[f] = t(f));
    if (credentials.email) {
        return {
            username: credentials.email,
            firstname: credentials.firstname,
            lastname: credentials.lastname,
            props
        }
    } else {
        return {
            username: 'anonymous',
            firstname: 'Anonymous',
            lastname: 'User',
            props
        }
    }
}

export const ProductFruits = ({ children }) => {
    const { t } = useTranslation();
    const [loaded, setLoaded] = useState();
    const [context, setContext] = useState();
    const clientConfig = useClientConfig();
    const credentials = useCredentials();

    const userInfo = useMemo(() => buildUserInfo(t, clientConfig, credentials), [credentials, t, clientConfig]);

    useEffect(() => {
        window.addEventListener('productfruits_ready', () => {
            setLoaded(true)
            setContext({
                tryStartTour: (...props) => window.productFruits.api.tours.tryStartTour(...props),
                isTourEligible: async (...props) => {
                    try {
                        const result = await window.productFruits.api.tours.isTourEligible(...props);
                        return result === 'eligible'
                    } catch (err) {
                        console.err("ProductFruits error " + err);
                        return false;
                    }
                }
            })
        });
    }, [])

    useEffect(() => {
        if (clientConfig.productFruits?.enable && loaded) {
            window.productFruits.identifyUser(userInfo);
        }
    }, [loaded, clientConfig.productFruits?.enable, userInfo]);

    useEffect(() => {
        if (clientConfig.productFruits?.enable && loaded === undefined) {
            setLoaded(() => {
                (function(w,d,u){
                    w.$productFruits=w.$productFruits||[];
                    w.productFruits=w.productFruits||{};w.productFruits.scrV='2';
                    let a=d.getElementsByTagName('head')[0];let r=d.createElement('script');r.async=1;r.src=u;a.appendChild(r);
                })(window,document,'https://app.productfruits.com/static/script.js');
                window.$productFruits.push(['init', clientConfig.productFruits.workspaceCode, 'en', buildUserInfo(t, clientConfig, credentials)])
                return false;
            })
        }
    }, [clientConfig.productFruits?.enable, loaded, clientConfig, t, credentials]);

    return <GuideContextProvider value={context}>
        {children}
    </GuideContextProvider>
}